<h2 mat-dialog-title>Login</h2>
<mat-dialog-content class="mat-typography">
    <div style="text-align:center;margin:24px 0 12px 0;position:relative" class="imgcontainer">
    <img  src="https://www.w3schools.com/howto/img_avatar2.png" alt="Avatar" class="avatar" style="max-height:200px;max-width:200px;">
    </div>  
    <form >        

        
        <mat-form-field style="width: 100%">
            <input matInput [(ngModel)]="data.name" style="padding:12px 20px;margin:8px 0;display:inline-block;width: 100%" class="w3-input" type="text" placeholder="Enter Username" name="uname" required>

            <input matInput [(ngModel)]="data.pw" style="padding:12px 20px;margin:8px 0;display:inline-block;width: 100%;" class="w3-input" type="password" placeholder="Enter Password" name="psw" required>  
          </mat-form-field>
        

        </form>


 
</mat-dialog-content>
<div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="data.pw == data.name && (data.name == 'teacher' || data.name == 'student')" cdkFocusInitial>Login</button>
    
  </div>